import { Box, Grid } from '@mui/material';
import InputForm   from '../../InputT';
import SearInputM from '../../SearchModal';
import Params from '../../../Types/ParamsPicklist';

let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchVille: Params = { CodeAgence: '', Table: "CdVille", Colonne1: "CdVille", Colonne2: "Libell", Colagence: '001', Choix: 22 }

const Tab2 = (props: { form?: any }) => {
  return (
    <div className='tabItem'>
      <div >
        <Grid container sx={{ width: "85%", position: "absolute" }}>
          <Grid item xs={12} md={6} className='border-left border'>
            <legend>Adresse Client</legend>
            <SearInputM notRequired width={7}  disabled={true} Titre='Recherche Type Adresse' label='Type Adresse' name="TYPADR" Parametre={searchTypAdr} form={props.form} />
            <SearInputM notRequired width={7}  disabled={true} Titre='Recherche Ville' label='Ville' name="vilCli" Parametre={searchVille} form={props.form} />

            <Grid container>
              <Grid item xs={12} md={6} className='border-left'>
                <InputForm  disabled={true} width={10} notRequired label='Boite Postale' name='adresse Postale' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} notRequired width={10} label='Numéro' name='Tel2' type='number' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} label='Téléphone Mobile' name='telCli' type='number' error=' ce Champ est obligatiore' min={9} maxLength={9} />
                <InputForm  disabled={true} width={10} notRequired label='Faxcli' name='FaxCli' type='text' error=' ce Champ est obligatiore' />
              </Grid>

              <Grid item xs={12} md={6} className='border-left'>
                <InputForm  disabled={true} width={10} label='Nom du quatier' name='nomQtier' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Numéro Rue' name='rueCli' type='text' error=' ce Champ est obligatiore' />
                <InputForm  noupercase disabled={true} width={10} notRequired label='Adresse Email' name='EmailCli' type='email' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} notRequired width={10} label='Adresse Domicile' name='NumDomCli' type='text' error=' ce Champ est obligatiore' />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6} className='border-left border'>

            <legend>Information Employeur/Famille</legend>
            <Grid container>
              <Grid item xs={12} md={6} className='border-left'>
                <InputForm  disabled={true} width={10} notRequired label='Nombre Enfant' name='nbrEnfant' type='number' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Nombre Personne à charge' name='nbrPersCharge' type='number' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Nom Employeur' name='NOMEMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Matricule Employeur' name='MATEMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='No Contribuable' name='NOCONT' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Nom du père' name='nompere' type='text' error=' ce Champ est obligatiore' />
              </Grid>

              <Grid item xs={12} md={6} className='border-left'>
                <InputForm  disabled={true} width={10} notRequired label='Revenu mensuel' name='revenuCli' type='number' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Adresse Employeur' name='ADREMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Numéro CNPS' name='NOCNPS' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Adresse Internet' name='numCnet' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Profession' name='profesion' type='text' error=' ce Champ est obligatiore' />
                <InputForm  disabled={true} width={10} notRequired label='Nom de la mère' name='nommere' type='text' error=' ce Champ est obligatiore' />
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </div>
    </div>

  );

}

export default Tab2;